import { FormLabel } from '@mui/material';
import { DatePicker, DatePickerProps } from '@mui/x-date-pickers/DatePicker/index.js';
import styled from 'styled-components';

interface StyledDateTimePickerProps extends DatePickerProps<unknown> {
  error?: boolean;
}

export const StyledDateTimePicker = styled(DatePicker)<StyledDateTimePickerProps>(({ theme, error }) => `
  .MuiInputBase-input {
      height: 40px;
      padding: 0 ${theme.uptimeSpace[8]}px 0 ${theme.uptimeSpace[12]}px;
      font-size: ${theme.uptimeFontSizes.desktop.fz4}px;
      font-family: ${theme.uptimeFonts.primary}${theme.uptimeFonts.secondary && `,${theme.uptimeFonts.secondary}`};
  }
  .MuiOutlinedInput-root.Mui-focused fieldset {
    border-color: ${theme.uptimeColors.mainTheme.primary};
  }
  .MuiOutlinedInput-root:not(.Mui-focused) fieldset {
    border-color: ${error ? '#d32f2f' : ''};
  }

  input + svg {
    cursor: pointer;
  }
`);

export const StyledFormLabel = styled(FormLabel)<{ boldLabel?: boolean }>(({ theme, boldLabel }) => `
  &.MuiFormLabel-root {
    margin-bottom: ${theme.uptimeSpace[4]}px;
    font-family: ${theme.uptimeFonts.primary}${theme.uptimeFonts.secondary && `,${theme.uptimeFonts.secondary}`};
    font-size: ${theme.uptimeFontSizes.desktop.fz4}px;
    color: ${theme.uptimeColors.textColors.primary};
    font-weight: ${boldLabel ? 'bold' : 'normal'};
    display: flex;

    &.Mui-focused {
      color: ${theme.uptimeColors.textColors.primary};
    }

    .MuiFormLabel-asterisk {
      color: red;
      font-weight: ${boldLabel ? 'bold' : 'normal'};
      padding-left: ${theme.uptimeSpace[2]}px;
    }
  }
`);